import jwt_dec from 'jwt-decode';
import { CodeDeSkin, CreoDiasSkin, SinergiseSkin, Skin } from './types';
import { Claims, DomainAccountWithDomain, SentinelUser } from '../../meta/types/user';
import { CONFIG } from '../../meta/types/config';
import Auth from '../auth';

let skin: Skin = SinergiseSkin();

export const setUserSkin = (user: SentinelUser, shAcc: DomainAccountWithDomain | undefined) => {
  skin = getAuthProviderSkin(user, shAcc);
};

const getAuthProviderSkin = (
  user: SentinelUser,
  shAcc: DomainAccountWithDomain | undefined,
): Skin => {
  const authorization = Auth.getAuthorization();
  if (authorization !== undefined) {
    const domainId = shAcc?.domainId ?? (jwt_dec(authorization.access_token) as Claims).did;
    switch (domainId) {
      case 5:
        return CreoDiasSkin(shAcc);
      case 6:
        return CodeDeSkin(shAcc);
      default:
        return SinergiseSkin(shAcc);
    }
  }
  return SinergiseSkin(shAcc);
};

export const getSkin = () => skin;

export function getAuthParametersByProvider(): { clientId: string; redirectUri: string } {
  const getHostname = (url: string | undefined): string =>
    url !== undefined ? new URL(url).hostname : '';
  const { hostname } = window.location;
  switch (hostname) {
    case getHostname(CONFIG.creoUrl):
      return { clientId: CONFIG.creoClientId, redirectUri: CONFIG.creoUrl };
    case getHostname(CONFIG.codeDEUrl):
      return { clientId: CONFIG.codeDEClientId, redirectUri: CONFIG.codeDEUrl };
    case getHostname(CONFIG.mundiUrl):
      return { clientId: CONFIG.mundiClientId, redirectUri: CONFIG.mundiUrl };
    default:
      return { clientId: CONFIG.clientId, redirectUri: CONFIG.redirect };
  }
}
